<template>
  <div class="home-page">
    <my-header :page_name="$t('signin.pageName')" show_usermenu></my-header>
    <div class="tiles-container">
      <home-tile
        v-for="(menuItem, index) in menuItemsA1"
        :key="index"
        :menuItem="menuItem"
      ></home-tile>
    </div>
    <!--  <div class="tiles-container">
      <home-tile v-for="(menuItem, index) in menuItemsA2" :key="index" :menuItem="menuItem"></home-tile>
    </div>-->
  </div>
</template>

<script>
import Header from "../components/reusable/header/Header";
import HomeTile from "../components/reusable/HomeTile";
import i18n from "@/locales";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      menuItemsA1: [
        {
          icon: "el-icon-document",
          name: "Задачи",
          menuSublist: [
            i18n.t("navigation.menuLinks.runTask.singleTask"),
            i18n.t("navigation.menuLinks.runTask.multiTask"),
            i18n.t("navigation.menuLinks.statusTask.running"),
            i18n.t("navigation.menuLinks.statusTask.finished"),
            i18n.t("navigation.menuLinks.statusTask.deleted"),
            i18n.t("navigation.menuLinks.commonTask.processes"),
            i18n.t("navigation.menuLinks.commonTask.services"),
            i18n.t("navigation.menuLinks.commonTask.logs"),
          ],
          routerLinks: [
            "runTaskLink",
            "multiTaskLink",
            "statusRunLink",
            "statusFinishLink",
            "statusDeleteLink",
            "processesLink",
            "servicesLink",
            "logsLink",
          ],
          breaks: [1, 4],
        },
        {
          icon: "el-icon-collection",
          name: "Справочники",
          menuSublist: [
            i18n.t("navigation.menuLinks.reference.databases"),
            i18n.t("navigation.menuLinks.reference.apps"),
            i18n.t("navigation.menuLinks.reference.servers"),
            i18n.t("navigation.menuLinks.reference.users"),
            i18n.t("navigation.menuLinks.reference.roles"),
            i18n.t("navigation.menuLinks.reference.appParams"),
          ],
          routerLinks: [
            "referenceBasesLink",
            "referenceSectionsLink",
            "referenceServersLink",
            "referenceUsersLink",
            "referenceRolesLink",
            "referenceAppParamsLink",
          ],
        },
        {
          icon: "el-icon-connection",
          name: "Конфигурация",
          menuSublist: [
            i18n.t("navigation.menuLinks.config.configTree"),
            i18n.t("navigation.menuLinks.config.visuals"),
            i18n.t("navigation.menuLinks.config.configTasks"),
            i18n.t("navigation.menuLinks.config.roleSections"),
            i18n.t("navigation.menuLinks.config.sectionTasks"),
            i18n.t("navigation.menuLinks.config.roleTasks"),
            i18n.t("navigation.menuLinks.cron.scheduler"),
            i18n.t("navigation.menuLinks.cron.history"),
          ],
          routerLinks: [
            "configTreeLink",
            "visualsLink",
            "configTasksLink",
            "roleSectionsLink",
            "sectionTasksLink",
            "roleTasksLink",
            "schedulerLink",
            "schedulerHistoryLink",
          ],
          breaks: [5],
        },
      ],
    };
  },
  components: {
    myHeader: Header,
    HomeTile,
  },
  methods: {
    removeFromArray(array) {
      //console.log('RemoveFromArray');
      for (let item = 0; item < array.length; item++) {
        for (let link = 0; link < array[item].routerLinks.length; link++) {
          if (
            this.currentUserDenial &&
            this.currentUserDenial.includes(array[item].routerLinks[link])
          ) {
            //console.log(array[item].routerLinks[link]);
            array[item].routerLinks.splice(link, 1);
            array[item].menuSublist.splice(link, 1);
            link--;
          }
        }
        if (array[item].routerLinks.length === 0) {
          array.splice(item, 1);
          item--;
        }
      }
    },
  },
  created() {
    // //console.log('in created', this.currentUserDenial);
    // //console.log(this.menuItemsArray);
    this.removeFromArray(this.menuItemsA1);
    // this.removeFromArray(this.menuItemsA2);
  },
  watch: {
    currentUserDenial() {
      this.removeFromArray(this.menuItemsA1);
      // this.removeFromArray(this.menuItemsA2);
    },
  },
  computed: {
    ...mapGetters(["currentUserDenial"]),
  },
};
</script>
<style scoped>
.home-page {
  /* height: calc(100vh - var(--header-height) - 10px); */
  height: 100%;
  background-color: var(--main-background);
}
.tiles-container {
  padding: 0px 5px 0px 10px;
  display: flex;
  justify-content: space-around;

  /* display: grid;
    justify-content: stretch;
    align-content: stretch; */
  /* grid-template-columns: [start-l] repeat(auto-fit, minmax(calc((100vw - 30px) / 4), 1fr)) [end-l]; */
  /* grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    grid-template-rows: auto;
    gap: 10px ; */
}
</style>